export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Node: [
      'ZoomMeetingNode',
      'CompanyNode',
      'BaseCompanyNode',
      'UserNode',
      'GroupNode',
      'PermissionNode',
      'CourseNode',
      'SiteNode',
      'FaviconGeneratorNode',
      'MosaicoNode',
      'ImageNode',
      'SurveyNode',
      'AssessmentNode',
      'AssessmentSessionNode',
      'CompanyUserInvitationNode',
      'QuestionNode',
      'AnswerNode',
      'SurveyResponseNode',
      'CourseParticipationNode',
      'CourseInvitationNode',
      'CertificateNode',
      'CertificateTemplateNode',
      'CourseCertificateTemplateMapNode',
      'CourseModuleCertificateTemplateMapNode',
      'CourseModuleNode',
      'AuthorNode',
      'AuthorsGroupNode',
      'ReminderNode',
      'TaskResultNode',
      'ReminderSnippetNode',
      'SurveyModuleNode',
      'ExternalWebinarModuleNode',
      'ChatModuleNode',
      'VideoModuleNode',
      'LayoutModuleNode',
      'DocumentModuleNode',
      'VideowallModuleNode',
      'IframeModuleNode',
      'CourseModuleAssessmentNode',
      'CourseModuleAssessmentSurveyNode',
      'CourseModuleAssessmentExternalWebinarNode',
      'CourseModuleAssessmentVideoNode',
      'VideoPlaybackProgressNode',
      'DbtemplatesNode',
      'CourseCategoryNode',
      'ThemeNode',
      'FaqType',
      'CourseParticipationImportFileNode',
      'CourseImageNode',
      'CourseUserParticipationQuotasNode',
      'AvatarNode',
      'FileNode',
      'ProfileNode',
      'PreferencesNode',
      'PresenceNode',
      'RoomNode',
      'WebLinkNode',
      'CompanyThemeCustomizationNode',
      'StreamServiceNode',
      'NoteNode',
      'PublicCompanyNode',
    ],
    QuestionUnion: ['QuestionNode'],
    SurveyUnion: ['SurveyNode'],
    CourseModuleUnion: [
      'SurveyModuleNode',
      'ExternalWebinarModuleNode',
      'CourseModuleNode',
      'ChatModuleNode',
      'VideoModuleNode',
      'LayoutModuleNode',
      'DocumentModuleNode',
      'IframeModuleNode',
      'VideowallModuleNode',
    ],
    CourseModuleAssessmentUnion: [
      'CourseModuleAssessmentVideoNode',
      'CourseModuleAssessmentExternalWebinarNode',
      'CourseModuleAssessmentSurveyNode',
      'CourseModuleAssessmentNode',
    ],
  },
};
export default result;
